import React from 'react';
import { HStack, Box, Text } from '@chakra-ui/react';

const GuessCounter = ({ guessesRemaining, maxGuesses = 6 }) => {
  // Create an array of boxes representing guesses
  const guessBoxes = Array.from({ length: maxGuesses }, (_, index) => ({
    id: index,
    used: index >= guessesRemaining
  }));

  return (
    <Box textAlign="center" my={4}>
      <Text mb={2} fontWeight="medium" color="gray.600">
        Guesses Remaining
      </Text>
      <HStack spacing={2} justify="center">
        {guessBoxes.map((box) => (
          <Box
            key={box.id}
            w="30px"
            h="30px"
            borderRadius="md"
            bg={box.used ? 'red.100' : 'green.100'}
            border="2px solid"
            borderColor={box.used ? 'red.400' : 'green.400'}
            opacity={box.used ? 0.7 : 1}
            transition="all 0.2s"
          />
        ))}
      </HStack>
    </Box>
  );
};

export default GuessCounter;